import { render, staticRenderFns } from "./YKEditorV2.vue?vue&type=template&id=1c6ca3be&scoped=true&"
import script from "./YKEditorV2.vue?vue&type=script&lang=js&"
export * from "./YKEditorV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ca3be",
  null
  
)

export default component.exports